import { AlertSeverityLevel } from '../../enums/alert-severity-level';

export class BuilderAnswerOption {
  guid?: string | null;
  text: string;
  includeFreeTextInput: boolean = false;
  index?: number;
  score?: number;
  alertSeverityLevel: AlertSeverityLevel;

  constructor(
    text: string,
    score?: number,
    index?: number,
    includeFreeTextInput: boolean = false,
  ) {
    this.text = text;
    this.index = index;
    this.includeFreeTextInput = includeFreeTextInput;
    this.score = score;
    this.alertSeverityLevel = AlertSeverityLevel.None;
  }
}
